import { observer } from "mobx-react";
import _ from "lodash";
import ManageAddOns from "./manage-addOns";
import { useState } from "react";
import ManageAddOnOpts from "../addOnOptions/manage-addOnOpts";

const AddOnsIndex = observer(() => {
  const [selectedTab, setSelectedTab] = useState(1);

  return (
    <div className="container mt-3">
      <ul className="nav nav-tabs nav-fill mb-3" id="addons" role="tablist">
        <li className="nav-item" role="presentation">
          <a
            data-mdb-tab-init
            className={`nav-link ${
              selectedTab === 1 ? "active bg-default text-white" : ""
            }`}
            href="#addons-tabs-1"
            role="tab"
            aria-controls="addons-tabs-1"
            aria-selected="true"
            onClick={() => setSelectedTab(1)}
          >
            Add-Ons
          </a>
        </li>
        <li className="nav-item" role="presentation">
          <a
            data-mdb-tab-init
            className={`nav-link ${
              selectedTab === 2 ? "active bg-default text-white" : ""
            }`}
            href="#opts-tabs-2"
            role="tab"
            aria-controls="opts-tabs-2"
            aria-selected="false"
            onClick={() => setSelectedTab(2)}
          >
            Add-On Options
          </a>
        </li>
      </ul>
      <div className="tab-content" id="addons-content">
        {selectedTab === 1 && (
          <div
            className="tab-pane fade show active"
            id="addons-tabs-1"
            role="tabpanel"
            aria-labelledby="addons-tabs-1"
          >
            <ManageAddOns />
          </div>
        )}
        {selectedTab === 2 && (
          <div
            className="tab-pane fade show active"
            id="opts-tabs-2"
            role="tabpanel"
            aria-labelledby="opts-tab-2"
          >
            <ManageAddOnOpts />
          </div>
        )}
      </div>
    </div>
  );
});

export default AddOnsIndex;
